import { HashLink } from './HashLink';
import { mediaUrl } from '../services/api';
import { useLanguage } from '../i18n/LanguageContext';
import { Statistic } from '../types/content';
import { HeroOverlay } from './HeroOverlay';
import { HeroBackground } from './HeroBackground';

type HeroSectionProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  imageUrl?: string;
  stats?: Statistic[];
  ctaText?: string;
  ctaLink?: string;
  pillars?: string[];
  variant?: 'default' | 'home-split' | 'services';
};

export function HeroSection({
  eyebrow,
  title,
  subtitle,
  imageUrl,
  stats,
  ctaText,
  ctaLink,
  pillars,
  variant = 'default',
}: HeroSectionProps) {
  const { t } = useLanguage();
  const bg = mediaUrl(imageUrl);
  const variantClass = variant === 'default' ? '' : `hero-${variant}`;
  // Banner yuksekligi website.css'teki ortak kuraldan gelir, satir ici stil verilmez.
  return (
    <section className={`hero ${variantClass}`}>
      {bg && <HeroBackground imageUrl={bg} correctBlueTone={variant === 'default'} />}
      {variant !== 'home-split' && (
        <HeroOverlay imageUrl={bg} preserveSourceTone={variant === 'services'} />
      )}
      <div className="container hero-inner">
        {eyebrow && <div className="eyebrow">{t(eyebrow)}</div>}
        <h1 dangerouslySetInnerHTML={{ __html: t(title) }} />
        {subtitle && <p className="lead">{t(subtitle)}</p>}

        {pillars && pillars.length > 0 && (
          <div className="pillars">
            {pillars.map((p) => (
              <span className="pillar-pill" key={p}>
                {t(p)}
              </span>
            ))}
          </div>
        )}

        {stats && stats.length > 0 && (
          <div className="hero-stats">
            {stats.map((s) => (
              <div key={s.id}>
                <b>{s.value}</b>
                <span>{t(s.label)}</span>
              </div>
            ))}
          </div>
        )}

        {ctaText && ctaLink && (
          <HashLink to={ctaLink} className="btn btn-red">
            {t(ctaText)}
          </HashLink>
        )}
      </div>
    </section>
  );
}
